import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getTermFromState } from '../../redux/selectors/i18n';
import { geti18n } from '../../utils';
import ErrorMessage from '../../components/ErrorMessage';
import CTAButton from '../../components/CTAButton';
import { createLocateARetailerURL, createRequestAQuoteURL } from '../../redux/selectors/paymentOptions';

// Stylesheets
import './styles';

/**
 * No incentives view isn't a standard view but rather an error state when there is
 * no incentive Data coming in from onit for that vehicle. This state may happen at
 * the beginning of a month as that is when onit and autodata are updating information
 */
class NoIncentiveView extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    linkURL: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    locateARetailerText: PropTypes.string.isRequired,
    requestAQuoteText: PropTypes.string.isRequired,
    locateARetailerURL: PropTypes.func.isRequired,
    requestAQuoteURL: PropTypes.func.isRequired
  };
  static defaultProps = {
    locateARetailerText: geti18n('offerPanel.summaryPanel.retailerButton'),
    requestAQuoteText: geti18n('offerPanel.summaryPanel.quoteButton'),
  }
  render() {
    const {
      title,
      message,
      locateARetailerText,
      locateARetailerURL,
      requestAQuoteText,
      requestAQuoteURL,
      linkText,
      linkURL
    } = this.props;
    return (
      <div className="no-incentives-view">
        <ErrorMessage title={title} message={message} linkText={linkText} linkURL={linkURL} />
        <div className="row">
          <div className="columns medium-6 ">
            <div className="button-group expanded">
              <CTAButton title={locateARetailerText} url={locateARetailerURL} linkName="LOCATE_A_DEALER" className="primary" />
              <CTAButton title={requestAQuoteText} url={requestAQuoteURL} linkName="REQUEST_A_QUOTE" className="secondary" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  title: getTermFromState(state, 'noIncentives.title'),
  message: getTermFromState(state, 'noIncentives.message'),
  linkText: getTermFromState(state, 'noIncentives.linkText'),
  linkURL: getTermFromState(state, 'noIncentives.linkURL'),
  locateARetailerURL: createLocateARetailerURL(state),
  requestAQuoteURL: createRequestAQuoteURL(state),
});


export default connect(mapStateToProps)(NoIncentiveView);



/** WEBPACK FOOTER **
 ** ./src/pages/NoIncentiveView/index.js
 **/